module.exports = __webpack_public_path__ + "site/img/209.141312ec.jpg";